import {
  SET_GIFT_CARD_DATA,
  SET_CURRENT_COLOR,
} from "../actions/gift-card-actions";

const initialState = {
  data: {},
  loaded: false,
  currentColor: "",
  currentColorIndex: 0,
};

const giftCard = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_GIFT_CARD_DATA:
      const { data } = payload;
      return {
        ...state,
        data,
        loaded: true,
      };
    case SET_CURRENT_COLOR:
      const { colorCode: currentColor, colors } = payload;
      const currentColorIndex = colors.findIndex(
        (color) => color.code === currentColor
      );
      return {
        ...state,
        currentColor,
        currentColorIndex,
      };
  }

  return state;
};

export default giftCard;
